let HeroActions = require("./hero-actions"),
    React = require("react");

// New Imports
import * as actions from "../../actions/actions";
import { connect } from "react-redux";

class Hero_Meta extends React.Component {
    componentWillReceiveProps(nextProps) {
        if (this.props.icon.id !== nextProps.icon.id) {
            if (this.state.showViewMoreIcons) {
                this.props.fetchViewMoreIcons(nextProps.icon.id, 4, 0);
                this.setState({
                    viewMoreOffset: 0
                });
            }
        }

        if (
            nextProps.apiResponse.actionType === "FETCH_VIEW_MORE_ICONS_SUCCESS"
        ) {
            if (this.state.isTransitioning === "") {
                this.setState({
                    isTransitioning: "animate"
                });
            }
        }
    }

    constructor(props) {
        super(props);

        let showViewMoreIcons = false;

        if (location.pathname.includes("collection") === false) {
            if (location.pathname.includes("term")) {
                showViewMoreIcons = true;
            } else if (location.pathname.includes("icon")) {
                showViewMoreIcons = true;
            } else if (location.pathname.includes("search")) {
                showViewMoreIcons = true;
            } else if (location.pathname.includes("browse")) {
                showViewMoreIcons = true;
            }
        }
        if (showViewMoreIcons) {
            this.props.fetchViewMoreIcons(props.icon.id, 4, 0);
        }
        this.state = {
            isTransitioning: "animate",
            viewMoreOffset: 0,
            showViewMoreIcons: showViewMoreIcons
        };
    }

    showPreviousLikeThis() {
        this.setState({
            isTransitioning: ""
        });

        if (this.state.viewMoreOffset > 0) {
            let newOffset = this.state.viewMoreOffset - 4;
            this.props.fetchViewMoreIcons(this.props.icon.id, 4, newOffset);
            this.setState({
                viewMoreOffset: newOffset
            });
        }
    }

    showMoreLikeThis() {
        this.setState({
            isTransitioning: ""
        });

        let newOffset = this.state.viewMoreOffset + 4;
        this.props.fetchViewMoreIcons(this.props.icon.id, 4, newOffset);
        this.setState({
            viewMoreOffset: newOffset
        });
    }

    renderViewMoreIcons() {
        let icons = [],
            viewMoreTitle = <span>&nbsp;</span>,
            viewMoreIcons = this.props.viewMore.icons;

        if (viewMoreIcons) {
            if (viewMoreIcons.length > 0) {
                if (this.props.icon.id === this.props.viewMore.iconId) {
                    viewMoreIcons.forEach(icon => {
                        let iconLink;

                        if (!this.props.viewMore.collection) {
                            // Related icons are from user
                            if (this.props.icon.uploader === undefined) {
                                iconLink = icon.permalink;
                                viewMoreTitle = `More from this creator`;
                            } else {
                                iconLink = `/${
                                    this.props.icon.uploader.username
                                }/uploads/?i=${icon.id}`;
                                viewMoreTitle = (
                                    <span>
                                        {"More from "}
                                        <a
                                            href={`${
                                                this.props.icon.uploader
                                                    .permalink
                                            }/uploads/`}
                                            className="text-link"
                                        >
                                            {this.props.icon.uploader.name}
                                        </a>
                                    </span>
                                );
                            }
                        } else {
                            // Related icons are in collection
                            let collectionName =
                                this.props.viewMore.collection.name
                                    .toLowerCase()
                                    .indexOf("collection") >= 1
                                    ? this.props.viewMore.collection.name
                                    : this.props.viewMore.collection.name +
                                      " Collection";

                            this.props.viewMore.collection.name;
                            viewMoreTitle = (
                                <span>
                                    {"More from "}
                                    <a
                                        href={`/${
                                            this.props.viewMore.collection
                                                .author.username
                                        }/collection/${
                                            this.props.viewMore.collection.slug
                                        }/`}
                                        className="text-link"
                                    >
                                        {collectionName}
                                    </a>
                                </span>
                            );
                            iconLink = `/${
                                this.props.viewMore.collection.author.username
                            }/collection/${
                                this.props.viewMore.collection.slug
                            }/?i=${icon.id}`;
                        }

                        icons.push(
                            <div key={icon.id} className="related-icon">
                                <a href={iconLink}>
                                    <img
                                        style={{
                                            width: "42px",
                                            margin: "auto",
                                            display: "block"
                                        }}
                                        src={icon.preview_url}
                                        title={icon.term}
                                    />
                                </a>
                            </div>
                        );
                    });
                }
            } else {
                return null;
            }
        } else {
            // Show loading icons
            let i;
            for (i = 0; i < 4; i++) {
                icons.push(
                    <div
                        key={i}
                        className="loading-icon-placeholder"
                        style={{
                            display: "block",
                            width: "42px",
                            height: "42px",
                            borderRadius: "50%",
                            backgroundColor: "#f2f2f2"
                        }}
                    />
                );
            }
            viewMoreTitle = (
                <span
                    style={{
                        border: "solid 1px transparent"
                    }}
                >
                    &nbsp;
                </span>
            );
        }

        if (this.state.showViewMoreIcons) {
            return (
                <div
                    className={`view-more ${this.state.isTransitioning}`}
                    style={{
                        paddingTop: "40px",
                        display: "flex",
                        position: "relative",
                        width: "100%",
                        flexDirection: "column"
                    }}
                >
                    <div className="weight-light padding-b-s">
                        {viewMoreTitle}
                    </div>
                    <div
                        className="view-more-container"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            backgroundColor: "#FAFAFA",
                            padding: "24px 12px",
                            border: "solid 1px #F2F2F2",
                            height: "100px",
                            width: "100%"
                        }}
                    >
                        <div
                            className={`view-more_arrow left-arrow ui_left-arrow ${
                                this.state.viewMoreOffset === 0
                                    ? "disabled"
                                    : ""
                            }`}
                            style={{
                                cursor: "pointer"
                            }}
                            onClick={this.showPreviousLikeThis.bind(this)}
                        />
                        {icons}
                        <div
                            className={`view-more_arrow right-arrow ui_right-arrow ${
                                (this.state.viewMoreOffset + 4) / 4 ===
                                Math.ceil(
                                    this.props.viewMore.totalRelatedCount / 4
                                )
                                    ? "disabled"
                                    : ""
                            }`}
                            style={{
                                cursor: "pointer"
                            }}
                            onClick={this.showMoreLikeThis.bind(this)}
                        />
                    </div>
                </div>
            );
        }
    }

    render() {
        let actionsKey,
            basicInfo,
            basicInfoKey,
            collection_title,
            collections,
            collectionsKey,
            country,
            get_static_prefix,
            i,
            icon,
            icon_title,
            j,
            k,
            license,
            metaKey,
            ref,
            ref1,
            sponsor_info,
            sponsor_logo,
            sponsored_by_title,
            tags,
            tagsKey,
            uploader,
            url,
            viewMoreIcons = this.renderViewMoreIcons();

        icon = this.props.icon;
        metaKey = "hero." + icon.id + ".meta";
        basicInfoKey = metaKey + ".info";
        actionsKey = metaKey + ".actions";
        tagsKey = metaKey + ".tags";
        collectionsKey = metaKey + ".collection";
        collections = [];
        tags = [];
        if (icon.collections) {
            for (
                i = j = 0, ref = icon.collections.length;
                0 <= ref ? j < ref : j > ref;
                i = 0 <= ref ? ++j : --j
            ) {
                collection_title =
                    "View the " + icon.collections[i].name + " collection";
                collections.push(
                    <div
                        key={collectionsKey + icon.collections[i].id}
                        className="hero-collections"
                    >
                        <a
                            href={icon.collections[i].permalink}
                            title={collection_title}
                        >
                            {icon.collections[i].name} Collection
                        </a>
                    </div>
                );
            }
        } else if (this.props.collection) {
            collection_title =
                "View the " + this.props.collection.name + " collection";
            collections.push(
                <div
                    key={collectionsKey + this.props.collection.id}
                    className="hero-collections"
                >
                    <a
                        href={this.props.collection.permalink}
                        title={collection_title}
                    >
                        {this.props.collection.name} Collection
                    </a>
                </div>
            );
        }
        if (icon.tags) {
            for (
                i = k = 0, ref1 = icon.tags.length;
                0 <= ref1 ? k < ref1 : k > ref1;
                i = 0 <= ref1 ? ++k : --k
            ) {
                url = "/term/" + icon.tags[i].slug + "/";
                tags.push(
                    <li
                        className="hero-tag"
                        key={tagsKey + "." + icon.tags[i].id}
                    >
                        <a
                            href={url}
                            title={icon.tags[i].slug}
                            className="text-link"
                        >
                            {icon.tags[i].slug.split("-").join(" ")}
                        </a>
                    </li>
                );
            }
        }
        if (icon.license_description === "public-domain") {
            license = (
                <a
                    className="icon-license"
                    href="https://creativecommons.org/publicdomain/zero/1.0/"
                    target="_blank"
                >
                    <i className="ui_public-domain" /> Public Domain
                </a>
            );
        } else {
            license = (
                <a
                    className="icon-license"
                    href="http://creativecommons.org/licenses/by/3.0/us/"
                    target="_blank"
                >
                    <i className="ui_cc" /> Creative Commons
                </a>
            );
        }
        if (icon.sponsor_id) {
            sponsored_by_title = "Sponsored by " + icon.sponsor.name;
            get_static_prefix = "/static/";
            sponsor_logo =
                get_static_prefix +
                "sponsor_logos" +
                icon.sponsor.permalink +
                "_dark.svg";
            sponsor_info = (
                <div className="sponsored-collection">
                    This icon is sponsored by
                    <a
                        href={icon.sponsor_campaign_link}
                        target="_blank"
                        title={sponsored_by_title}
                    >
                        <img
                            className="hero-sponsor-logo"
                            src={sponsor_logo}
                            alt={icon.sponsor.name}
                            width="64"
                            height="32"
                        />
                    </a>
                </div>
            );
        }
        if (icon.uploader) {
            if (icon.uploader.location) {
                country = icon.uploader.location.split(", ");
                country = country[country.length - 1];
                country = (
                    <span className="uploader-location">, {country}</span>
                );
            }
            if (icon.uploader.name) {
                uploader = (
                    <span className="designer">
                        By{" "}
                        <a href={icon.uploader.permalink}>
                            {icon.uploader.name}
                        </a>
                        {country}
                    </span>
                );
            }
        }

        icon_title = (
            <div className="hero-title">
                <h1 className="main-term">
                    {icon.term}&nbsp;
                    <span className="hover-context-container">
                        <a href="#" className="hover-context ui_tag">
                            <span className="visuallyhidden">tags</span>
                        </a>
                        <div
                            className="hover-context-box"
                            style={{
                                fontSize: "12px",
                                minWidth: "180px",
                                width: "auto"
                            }}
                        >
                            <ul
                                style={{ maxHeight: "300px", overflow: "auto" }}
                            >
                                {tags}
                            </ul>
                        </div>
                    </span>
                </h1>
                {uploader}
            </div>
        );

        basicInfo = (
            <section key={basicInfoKey} className="hero-basic-info">
                {icon_title}
            </section>
        );

        return (
            <section key={metaKey} className="hero-meta">
                {sponsor_info}
                {basicInfo}
                <HeroActions
                    icon={icon}
                    key={actionsKey}
                    showShareModal={this.props.showShareModal}
                    download={this.props.download}
                    store={this.props.store}
                />
                {viewMoreIcons}
            </section>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let apiResponse = state.apiResponse,
        viewMore = { icons: [] };

    if (state.icons.viewMore) {
        state.icons.viewMore.keys.forEach(viewMoreKey => {
            viewMore.icons.push(state.icons.viewMore[viewMoreKey]);
        });
        viewMore.collection = state.icons.viewMore.collection;
        viewMore.iconId = state.icons.viewMore.iconId;
        viewMore.totalRelatedCount = state.icons.viewMore.total_related_count;
    }

    return {
        apiResponse,
        viewMore
    };
}

module.exports = connect(mapStateToProps, {
    fetchViewMoreIcons: actions.fetchViewMoreIcons
})(Hero_Meta);
